/**
 * Meta Pixel, loaded lazily so its ~220 KB never competes with the hero image
 * for bandwidth. It boots on the first visitor interaction, or a few seconds
 * after load — whichever happens first.
 */
export const PIXEL_ID = '1683149889416153'

type PixelArgs = unknown[]

interface FbqFunction {
  (...args: PixelArgs): void
  callMethod?: (...args: PixelArgs) => void
  queue: PixelArgs[]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: FbqFunction
    _fbq?: FbqFunction
  }
}

let initialized = false

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  if (!window.fbq) {
    const fbq: FbqFunction = function (...args: PixelArgs) {
      if (fbq.callMethod) {
        fbq.callMethod(...args)
      } else {
        fbq.queue.push(args)
      }
    } as FbqFunction

    fbq.queue = []
    fbq.loaded = true
    fbq.version = '2.0'
    window.fbq = fbq
    window._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
  }

  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')

  // Noscript fallback so the view is still counted without JS execution.
  if (!document.getElementById('fb-pixel-noscript')) {
    const fallback = document.createElement('noscript')
    fallback.id = 'fb-pixel-noscript'
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.alt = ''
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
    fallback.appendChild(img)
    document.body.appendChild(fallback)
  }
}

export function trackPixelEvent(event: string, params?: Record<string, unknown>) {
  // A click can happen before the lazy boot, so make sure the pixel exists first.
  initMetaPixel()
  window.fbq?.('track', event, params)
}
